import type { Prisma } from './generated/index.js';

export type CreateFeatureFlagDto = {
  key: string;
  description?: string | null;
  enabled?: boolean;
};

/** Validate a feature flag key format (snake_case, alphanumeric + underscore) */
export function isValidFeatureFlagKey(key: string): boolean {
  return /^[a-z][a-z0-9_]*$/i.test(key) && key.length <= 100 && key.length > 0;
}

export type UpsertFeatureFlagDto = {
  description?: string | null;
  enabled?: boolean;
};

export type FeatureFlagDto = {
  id: string;
  key: string;
  description: string | null;
  enabled: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type FeatureFlagDetail = {
  enabled: boolean;
  description: string | null;
};

export type FeatureFlagsDto = {
  enableKioskDashboardButton: FeatureFlagDetail;
  devNoInterview: FeatureFlagDetail;
  devNoTimeout: FeatureFlagDetail;
  enableSimulationMode: FeatureFlagDetail;
  enableFranceTravailConnect: FeatureFlagDetail;
  enableFtJobsource: FeatureFlagDetail;
  enableCibliAtsJobsource: FeatureFlagDetail;
  enableCibliAtsLegacyJobsource: FeatureFlagDetail;
  enableGenderize: FeatureFlagDetail;
  enableDevOtpBypass: FeatureFlagDetail;
  enableMaintenanceMode: FeatureFlagDetail;
  enableSecretPin: FeatureFlagDetail;
  cvThemes: FeatureFlagDetail;
  enableBoothDefaultLocale: FeatureFlagDetail;
};

export type FeatureFlagTargetDto = {
  id: string;
  featureFlagId: string;
  boothId: string;
  enabled: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type FeatureFlagWithTargets = FeatureFlagDto & {
  targets: FeatureFlagTargetDto[];
  webEnabled: boolean;
  boothEnabled: boolean;
  appEnabled: boolean;
  tabletteEnabled: boolean;
  status: 'active' | 'partial' | 'inactive';
};

export type UpsertFeatureFlagTargetDto = {
  boothId: string;
  enabled: boolean;
};
